import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import LinearProgress from "@mui/material/LinearProgress";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import axios from "axios";

export default function SignIn() {
  const [signinprogress, setSigninprogress] = useState(false);
  const [courseInProgress, setCourseInProgress] = useState(false);
  const [signedIn, setSignedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (signedIn) {
      navigate("/coursepage");
    }
  }, [signedIn, navigate]);

  const exchangeToken = async (token) => {
    try {
      setSigninprogress(true);
      const tokenResp = await axios(
        `${process.env.REACT_APP_API_GATEWAY_URL}app/v1/token`,
        {
          headers: {
            oauthtoken: token,
            "x-api-key": process.env.REACT_APP_API_TOKEN_API_KEY,
          },
        }
      );
      const session = {
        token: tokenResp.headers["x-marvelapi-token"],
        firstName: tokenResp.data.fn,
        lastName: tokenResp.data.ln,
      };

      setCourseInProgress(true);
      const coursesResp = await axios(
        `${process.env.REACT_APP_API_GATEWAY_URL}app/v1/courses`,
        {
          headers: {
            Authorization: session.token,
          },
        }
      );
      session.mycourses = coursesResp.data;
      localStorage.setItem("userInfo", JSON.stringify(session));
      setCourseInProgress(false);
      setSigninprogress(false);
      setSignedIn(true);
    } catch (error) {
      setSigninprogress(false);
      setCourseInProgress(false);
      console.error("Error during sign-in flow:", error);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      {signinprogress ? (
        <Box sx={{ mt: 4, textAlign: "center" }}>
          <Typography>
            {courseInProgress ? "Getting your courses..." : "Signing in..."}
          </Typography>
          <LinearProgress color="secondary" />
        </Box>
      ) : (
        !signedIn && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {/* <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography> */}
            <Box sx={{ mt: 2 }}>
              <GoogleOAuthProvider
                clientId={process.env.REACT_APP_GOOGLE_OATH_CLIENT_ID}
              >
                <GoogleLogin
                  onSuccess={(credentialResponse) => {
                    setSigninprogress(true);
                    exchangeToken(credentialResponse.credential);
                  }}
                  onError={() => {
                    console.log("Login Failed");
                  }}
                />
              </GoogleOAuthProvider>
            </Box>
          </Box>
        )
      )}
    </Container>
  );
}
